<template>
   <el-form ref="userRef" class="profile-form" :model="user" :rules="rules" label-width="200px">
      <el-form-item :label="$t('global.userName')" prop="nickName">
         <el-input v-model="user.nickName" maxlength="30" />
      </el-form-item>
      <el-form-item :label="$t('global.userEmail')" prop="email">
         <el-input v-model="user.email" maxlength="50" />
      </el-form-item>
      <el-form-item class="profile-form__actions">
         <el-button type="primary" @click="submit">{{ $t('global.save') }}</el-button>
         <el-button type="danger" @click="close">{{ $t('global.close') }}</el-button>
      </el-form-item>
   </el-form>
</template>

<script setup>
import { updateUserProfile } from "@/api/system/user";

const props = defineProps({
  user: {
    type: Object
  }
});

const { proxy } = getCurrentInstance();

const rules = ref({
  nickName: [{ required: true, message: "ユーザー名を入力してください", trigger: "blur" }],
  email: [{ required: true, message: "メールアドレスを入力してください", trigger: "blur" }, { type: "email", message: "正しいメールアドレスを入力してください", trigger: ["blur", "change"] }],
});

/** 提交按钮 */
function submit() {
  proxy.$refs.userRef.validate(valid => {
    if (valid) {
      // 页面不再提供性别选择，未设置时默认「男」(0)，避免后端必填校验失败
      const payload = { ...props.user, sex: props.user.sex || "0" };
      updateUserProfile(payload).then(response => {
        proxy.$modal.msgSuccess(proxy.$t('global.editSuccess'));
      });
    }
  });
};
/** 关闭按钮 */
function close() {
  proxy.$tab.closePage();
};
</script>

<style lang="scss" scoped>
.profile-form {
  padding-right: 12px;
  box-sizing: border-box;
}
/* 按钮行：右对齐；防止打开 dialog 时被压缩、重叠 */
.profile-form :deep(.profile-form__actions .el-form-item__content) {
  min-width: 200px;
  display: flex;
  flex-wrap: nowrap;
  gap: 8px;
  overflow: visible;
  justify-content: flex-end;
}

/* 手机端：通过设置 el-form-item__content 宽度加宽 input 区域 */
@media (max-width: 768px) {
  .profile-form {
    width: 100%;
  }
  .profile-form :deep(.el-form-item__label) {
    width: 120px !important;
    min-width: 120px !important;
    padding-right: 8px;
    white-space: nowrap;
    overflow: visible;
  }
  .profile-form :deep(.el-form-item__content) {
    flex: 1;
    min-width: 0;
    box-sizing: border-box;
  }
  /* 手机端按钮行：整行占满，不预留 label 宽度，避免右侧被裁切 */
  .profile-form :deep(.profile-form__actions.el-form-item .el-form-item__label) {
    width: 0 !important;
    min-width: 0 !important;
    padding: 0 !important;
    overflow: hidden;
  }
  .profile-form :deep(.profile-form__actions .el-form-item__content) {
    margin-left: 0 !important;
    width: 100% !important;
    max-width: 100%;
    display: flex;
    flex-wrap: nowrap;
    gap: 8px;
    overflow: visible;
    box-sizing: border-box;
    justify-content: flex-end;
  }
  .profile-form :deep(.profile-form__actions .el-button) {
    flex: none;
    white-space: nowrap;
  }
  .profile-form :deep(.el-input) {
    width: 100%;
  }
}
</style>
